<template>
  <a-modal
    v-model="show"
    :centered="true"
    :keyboard="false"
    :footer="null"
    :width="500"
    :closable="!imageIsChange"
    :maskClosable="!imageIsChange"
    @cancel="handleCancleClick"
    title="修改系统图标">
    <a-form :form="form">
        <a-form-item label='系统图标' v-bind="formItemLayout">
            <div>
                <label for="files" class="img1" style="display: inline-block;margin-right: 10px">
                    <div>
                        <a-button @click="handleAddPic">上传</a-button>
                    </div>
                    <input name="file" ref="filed" type="file" style="display:none" id="files" @change="previewFile">
                </label>
                <a-button @click="handleSubmit" type="primary">完成</a-button>
            </div>
        </a-form-item>
        <a-row  style="width: 100%;">
            <a-col :span="6" :offset="4">
                <div>
                    <img style="width: 200px;height:200px" :src="systemIcon" @click="handlePreview" />
                </div>
            </a-col>
        </a-row>
        <a-modal centered :width="400" :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%;margin-top:15px" :src="systemIcon" />
        </a-modal>
    </a-form>
  </a-modal>
</template>

<script>
const formItemLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 }
}
import {mapState} from 'vuex'
export default {
  name: 'systemIcon',
  data () {
    return {
      formItemLayout,
      form: this.$form.createForm(this),
      validateStatus: '',
      help: '',
      systemIcon: '',
      oldsystemIcon: '',
      previewVisible: false,
      imageIsChange: false
    }
  },
  props: {
    iconVisiable: {
      default: false,
      type: Boolean
    },
  },
  computed: {
    show: {
      get: function () {
        return this.iconVisiable
      },
      set: function () {
      }
    },
    ...mapState({
      user: state => state.account.user
    }),
  },
  watch: {
    iconVisiable () {
        if (this.iconVisiable) {
          this.systemIcon = this.$db.get('systemLogo')
          this.oldsystemIcon = this.$db.get('systemLogo')
        }
    } 
  },
  methods: {
    handleAddPic () {
      this.$refs.filed.click()
    },
    previewFile () {   
      var fileDom = this.$refs.filed
      let file = fileDom.files[0]
      console.log(file)
      if(file.size > 1024 * 1024) {
        alert('图片大小不能超过 1MB!');
        return false;
      }
      var imgurl = window.URL.createObjectURL(file)
      let formData = new FormData()
      formData.append('file', file)
      formData.append('id', this.user.tenantId)
      this.$upload('user/uploadLogo', formData).then((r) => {
        if (this.imageIsChange) {
          this.oldsystemIcon = this.systemIcon
        }
        this.handleClearPic()
        this.systemIcon = r.data.imgUrl
        // this.$store.commit('setting/setSystemIcon', this.systemIcon)
        this.$db.save('systemLogo', this.systemIcon)
        this.imageIsChange = true
      }).catch((err) => {
        console.log(err)
      })
    },
    handleClearPic () {
      this.$delete('user/deleteLogo?imgPath=' + this.oldsystemIcon + '&id=' + this.user.tenantId).then((r) => {
        console.log(r)
      })
    },
    handleCancel () {
      this.previewVisible = false
    },
    handlePreview (file) {
      this.previewVisible = true
    },
    handleSubmit () {
      this.imageIsChange = false
      this.$emit('success')
    },
    handleCancleClick () {
      this.imageIsChange = false
      this.$emit('close')
    },
    reset () {
      this.form.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/system/systemicon/systemIcon.vue